import { SaveButton } from "components/Buttons"
import {
  SwitchInputField,
  TextAreaField,
  TextField,
} from "components/RenderInput"
import { FORM_NAMES, LOCAL_STORAGE_TAGS } from "constants/index"
import React from "react"
import { connect } from "react-redux"
import {
  Row,
  Col,
  Card,
  CardBody,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
} from "reactstrap"
import { change, Field, formValueSelector, getFormSyncErrors } from "redux-form"
import { updateClientSettings } from "store/actions"
import {
  mapSettingsFormToApi,
  fieldLevelValidation,
  minValueValidation,
  maxValueValidation,
} from "../utils"

const SettingsTab = ({
  vendorConfig,
  visitorStatus,
  change,
  formSyncErrors,
  updateClientSettings,
  settingsFormValues,
}) => {
  // handle save btn
  const saveHandler = async () => {
    const currentVendor = localStorage.getItem(LOCAL_STORAGE_TAGS.VENDOR_ID_TAG)
    if (!formSyncErrors.hasOwnProperty("settings_setup")) {
      // Update client settings
      await updateClientSettings({
        updateLocalStorage: +currentVendor === vendorConfig?.vendor_id,
        params: {
          ...vendorConfig,
          ...mapSettingsFormToApi(settingsFormValues, vendorConfig),
        },
      })
    }
  }

  return (
    <React.Fragment>
      <Row className="my-3">
        <Col>
          <Card>
            <CardBody>
              <Row className="my-3">
                <Col>
                  <Field
                    component={TextAreaField}
                    name="imageStyle"
                    label="Image styles"
                    validate={fieldLevelValidation}
                  />
                </Col>
              </Row>
              <Row className="my-3">
                <Col>
                  <Field
                    component={TextField}
                    name="newAccountText"
                    label="Create New Account Text"
                    validate={fieldLevelValidation}
                  />
                </Col>
              </Row>
              <Row className="my-3">
                <Col>
                  <Field
                    component={TextField}
                    name="logInButtonText"
                    label="Log In Button Text"
                    validate={fieldLevelValidation}
                  />
                </Col>
              </Row>
              <Row className="my-3">
                <Col>
                  <Field
                    component={TextField}
                    name="restrictedAccessMessage"
                    label="Restricted Access Message"
                    validate={fieldLevelValidation}
                  />
                </Col>
              </Row>
              <Row className="my-3">
                <Col>
                  <Field
                    component={TextField}
                    name="appDisabledText"
                    label="App Disabled Text"
                    validate={fieldLevelValidation}
                  />
                </Col>
              </Row>
              <Row className="my-3">
                <Col>
                  <Field
                    component={TextField}
                    name="deleteAccText"
                    label="Delete Account Text (displayed to user)"
                  />
                </Col>
              </Row>
              {/* <Row className="my-3">
                <Col>
                  <Field
                    component={TextField}
                    name="googleMapsKey"
                    label="Google Maps Key"
                  />
                </Col>
              </Row> */}
              <Row className="my-3">
                <Col>
                  <Field
                    component={TextField}
                    name="temporaryPwd"
                    label="Temporary Password (set for the users that will get a tempotary password)"
                  />
                </Col>
              </Row>
              <Row style={{ borderBottom: "1px solid lightgray" }}>
                <Col xs={11}>
                  <p className="pt-3">Ads Enabled</p>
                </Col>
                <Col xs={1} className={"d-flex justify-content-end"}>
                  <Field
                    name="adsEnabled"
                    component={SwitchInputField}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    onColor="#2ECC71"
                    offColor="#E74C3C"
                    height={20}
                    width={40}
                    handleDiameter={18}
                  />
                </Col>
              </Row>
              <Row style={{ borderBottom: "1px solid lightgray" }}>
                <Col xs={11}>
                  <p className="pt-3">App Enabled</p>
                </Col>
                <Col xs={1} className={"d-flex justify-content-end"}>
                  <Field
                    name="appEnabled"
                    component={SwitchInputField}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    onColor="#2ECC71"
                    offColor="#E74C3C"
                    height={20}
                    width={40}
                    handleDiameter={18}
                  />
                </Col>
              </Row>
              <Row style={{ borderBottom: "1px solid lightgray" }}>
                <Col xs={11}>
                  <p className="pt-3">App notifications enabled</p>
                </Col>
                <Col xs={1} className={"d-flex justify-content-end"}>
                  <Field
                    name="appNotificationsEnabled"
                    component={SwitchInputField}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    onColor="#2ECC71"
                    offColor="#E74C3C"
                    height={20}
                    width={40}
                    handleDiameter={18}
                  />
                </Col>
              </Row>
              <Row style={{ borderBottom: "1px solid lightgray" }}>
                <Col xs={11}>
                  <p className="pt-3">App User List</p>
                </Col>
                <Col xs={1} className={"d-flex justify-content-end"}>
                  <Field
                    name="appUserList"
                    component={SwitchInputField}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    onColor="#2ECC71"
                    offColor="#E74C3C"
                    height={20}
                    width={40}
                    handleDiameter={18}
                  />
                </Col>
              </Row>
              <Row style={{ borderBottom: "1px solid lightgray" }}>
                <Col xs={11}>
                  <p className="pt-3">Association Client</p>
                </Col>
                <Col xs={1} className={"d-flex justify-content-end"}>
                  <Field
                    name="associationClient"
                    component={SwitchInputField}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    onColor="#2ECC71"
                    offColor="#E74C3C"
                    height={20}
                    width={40}
                    handleDiameter={18}
                  />
                </Col>
              </Row>
              <Row style={{ borderBottom: "1px solid lightgray" }}>
                <Col xs={11}>
                  <p className="pt-3">AxisCare Integration</p>
                </Col>
                <Col xs={1} className={"d-flex justify-content-end"}>
                  <Field
                    name="axisCareEnabled"
                    component={SwitchInputField}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    onColor="#2ECC71"
                    offColor="#E74C3C"
                    height={20}
                    width={40}
                    handleDiameter={18}
                  />
                </Col>
              </Row>
              <Row style={{ borderBottom: "1px solid lightgray" }}>
                <Col xs={11}>
                  <p className="pt-3">
                    Business unit experiences visible to all
                  </p>
                </Col>
                <Col xs={1} className={"d-flex justify-content-end"}>
                  <Field
                    name="buVisibleToAll"
                    component={SwitchInputField}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    onColor="#2ECC71"
                    offColor="#E74C3C"
                    height={20}
                    width={40}
                    handleDiameter={18}
                  />
                </Col>
              </Row>
              <Row style={{ borderBottom: "1px solid lightgray" }}>
                <Col xs={11}>
                  <p className="pt-3">Categorize Experiences</p>
                </Col>
                <Col xs={1} className={"d-flex justify-content-end"}>
                  <Field
                    name="categorizeExp"
                    component={SwitchInputField}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    onColor="#2ECC71"
                    offColor="#E74C3C"
                    height={20}
                    width={40}
                    handleDiameter={18}
                  />
                </Col>
              </Row>
              <Row style={{ borderBottom: "1px solid lightgray" }}>
                <Col xs={11}>
                  <p className="pt-3">Confirm Email upon Sign Up</p>
                </Col>
                <Col xs={1} className={"d-flex justify-content-end"}>
                  <Field
                    name="confirmEmail"
                    component={SwitchInputField}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    onColor="#2ECC71"
                    offColor="#E74C3C"
                    height={20}
                    width={40}
                    handleDiameter={18}
                  />
                </Col>
              </Row>
              <Row style={{ borderBottom: "1px solid lightgray" }}>
                <Col xs={11}>
                  <p className="pt-3">Contact Us</p>
                </Col>
                <Col xs={1} className={"d-flex justify-content-end"}>
                  <Field
                    name="contactUs"
                    component={SwitchInputField}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    onColor="#2ECC71"
                    offColor="#E74C3C"
                    height={20}
                    width={40}
                    handleDiameter={18}
                  />
                </Col>
              </Row>
              <Row
                className="ms-5"
                style={{ borderBottom: "1px solid lightgray" }}
              >
                <Col xs={10} sm={11}>
                  <p className="pt-3">
                    Chat With Contacts Only (Contact Us must be enabled)
                  </p>
                </Col>
                <Col xs={2} sm={1} className={"d-flex justify-content-end"}>
                  <Field
                    name="chatWithContactsOnly"
                    component={SwitchInputField}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    onColor="#2ECC71"
                    offColor="#E74C3C"
                    height={20}
                    width={40}
                    handleDiameter={18}
                  />
                </Col>
              </Row>
              <Row
                className="ms-5"
                style={{ borderBottom: "1px solid lightgray" }}
              >
                <Col xs={11}>
                  <p className="pt-3">App Wide Private Message</p>
                </Col>
                <Col xs={1} className={"d-flex justify-content-end"}>
                  <Field
                    name="appWidePrivateMessage"
                    component={SwitchInputField}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    onColor="#2ECC71"
                    offColor="#E74C3C"
                    height={20}
                    width={40}
                    handleDiameter={18}
                  />
                </Col>
              </Row>
              <Row style={{ borderBottom: "1px solid lightgray" }}>
                <Col xs={11}>
                  <p className="pt-3">Display Dashboard</p>
                </Col>
                <Col xs={1} className={"d-flex justify-content-end"}>
                  <Field
                    name="displayDashboard"
                    component={SwitchInputField}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    onColor="#2ECC71"
                    offColor="#E74C3C"
                    height={20}
                    width={40}
                    handleDiameter={18}
                  />
                </Col>
              </Row>
              <Row style={{ borderBottom: "1px solid lightgray" }}>
                <Col xs={11}>
                  <p className="pt-3">Enable eCommerce</p>
                </Col>
                <Col xs={1} className={"d-flex justify-content-end"}>
                  <Field
                    name="ecommerce_enabled"
                    component={SwitchInputField}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    onColor="#2ECC71"
                    offColor="#E74C3C"
                    height={20}
                    width={40}
                    handleDiameter={18}
                    onChange={(event, newValue) => {
                      if (!newValue) {
                        change("settings_setup.booking_payments_enabled", false)
                      }
                    }}
                  />
                </Col>
              </Row>
              <Row
                className="ms-5"
                style={{ borderBottom: "1px solid lightgray" }}
              >
                <Col xs={11}>
                  <p className="pt-3">Enable payments for Booking</p>
                </Col>
                <Col xs={1} className={"d-flex justify-content-end"}>
                  <Field
                    name="booking_payments_enabled"
                    component={SwitchInputField}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    onColor="#2ECC71"
                    offColor="#E74C3C"
                    height={20}
                    width={40}
                    handleDiameter={18}
                    disabled={!settingsFormValues?.ecommerce_enabled}
                  />
                </Col>
              </Row>
              <Row
                className="ms-5"
                style={{ borderBottom: "1px solid lightgray" }}
              >
                <Col xs={"auto"}>
                  <p className="pt-3">Application Fee</p>
                </Col>
                <Col xs={"auto"} className={"align-content-center"}>
                  <InputGroup>
                    <Field
                      name="payment_application_fee"
                      component={TextField}
                      type="number"
                      disabled={!settingsFormValues?.ecommerce_enabled}
                      min={0}
                      validate={[minValueValidation]}
                      digitsOnly={true}
                    />
                    <InputGroupAddon addonType="append">
                      <InputGroupText>$</InputGroupText>
                    </InputGroupAddon>
                  </InputGroup>
                </Col>
              </Row>
              <Row
                className="ms-5"
                style={{ borderBottom: "1px solid lightgray" }}
              >
                <Col xs={"auto"}>
                  <p className="pt-3">Commission</p>
                </Col>
                <Col xs={"auto"} className={"align-content-center"}>
                  <InputGroup>
                    <Field
                      name="payment_commission"
                      component={TextField}
                      type="number"
                      disabled={!settingsFormValues?.ecommerce_enabled}
                      min={0}
                      max={100}
                      validate={[minValueValidation, maxValueValidation]}
                      digitsOnly={true}
                    />
                    <InputGroupAddon addonType="append">
                      <InputGroupText>%</InputGroupText>
                    </InputGroupAddon>
                  </InputGroup>
                </Col>
              </Row>
              <Row
                className="ms-5"
                style={{ borderBottom: "1px solid lightgray" }}
              >
                <Col xs={"auto"}>
                  <p className="pt-3">Subscription Commission</p>
                </Col>
                <Col xs={"auto"} className={"align-content-center"}>
                  <InputGroup>
                    <Field
                      name="subscription_application_fee_percentage"
                      component={TextField}
                      type="number"
                      disabled={!settingsFormValues?.ecommerce_enabled}
                      min={0}
                      max={100}
                      validate={[minValueValidation, maxValueValidation]}
                      digitsOnly={true}
                    />
                    <InputGroupAddon addonType="append">
                      <InputGroupText>%</InputGroupText>
                    </InputGroupAddon>
                  </InputGroup>
                </Col>
              </Row>
              <Row
                className="ms-5"
                style={{ borderBottom: "1px solid lightgray" }}
              >
                <Col xs={"auto"}>
                  <p className="pt-3">Ticket Fee</p>
                </Col>
                <Col xs={"auto"} className={"align-content-center"}>
                  <InputGroup>
                    <Field
                      name="ticket_application_fee"
                      component={TextField}
                      type="number"
                      disabled={!settingsFormValues?.ecommerce_enabled}
                      min={0}
                      validate={[minValueValidation]}
                      digitsOnly={true}
                    />
                    <InputGroupAddon addonType="append">
                      <InputGroupText>$</InputGroupText>
                    </InputGroupAddon>
                  </InputGroup>
                </Col>
              </Row>
              <Row
                className="ms-5"
                style={{ borderBottom: "1px solid lightgray" }}
              >
                <Col xs={"auto"}>
                  <p className="pt-3">Ticket Commission</p>
                </Col>
                <Col xs={"auto"} className={"align-content-center"}>
                  <InputGroup>
                    <Field
                      name="ticket_application_fee_percentage"
                      component={TextField}
                      type="number"
                      disabled={!settingsFormValues?.ecommerce_enabled}
                      min={0}
                      max={100}
                      validate={[minValueValidation, maxValueValidation]}
                      digitsOnly={true}
                    />
                    <InputGroupAddon addonType="append">
                      <InputGroupText>%</InputGroupText>
                    </InputGroupAddon>
                  </InputGroup>
                </Col>
              </Row>
              <Row style={{ borderBottom: "1px solid lightgray" }}>
                <Col xs={11}>
                  <p className="pt-3">Explore The App screen</p>
                </Col>
                <Col xs={1} className={"d-flex justify-content-end"}>
                  <Field
                    name="exploreTheAppScreen"
                    component={SwitchInputField}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    onColor="#2ECC71"
                    offColor="#E74C3C"
                    height={20}
                    width={40}
                    handleDiameter={18}
                  />
                </Col>
              </Row>
              <Row style={{ borderBottom: "1px solid lightgray" }}>
                <Col xs={11}>
                  <p className="pt-3">
                    Forced update enabled for the previous version
                  </p>
                </Col>
                <Col xs={1} className={"d-flex justify-content-end"}>
                  <Field
                    name="forcedUpdateEnabled"
                    component={SwitchInputField}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    onColor="#2ECC71"
                    offColor="#E74C3C"
                    height={20}
                    width={40}
                    handleDiameter={18}
                  />
                </Col>
              </Row>
              <Row style={{ borderBottom: "1px solid lightgray" }}>
                <Col xs={11}>
                  <p className="pt-3">Hyperlinks</p>
                </Col>
              </Row>
              <Row
                className="ms-5"
                style={{ borderBottom: "1px solid lightgray" }}
              >
                <Col xs={11}>
                  <p className="pt-3">Communication</p>
                </Col>
                <Col xs={1} className={"d-flex justify-content-end"}>
                  <Field
                    name="communicationHyperlinks"
                    component={SwitchInputField}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    onColor="#2ECC71"
                    offColor="#E74C3C"
                    height={20}
                    width={40}
                    handleDiameter={18}
                  />
                </Col>
              </Row>
              <Row
                className="ms-5"
                style={{ borderBottom: "1px solid lightgray" }}
              >
                <Col xs={11}>
                  <p className="pt-3">NFC</p>
                </Col>
                <Col xs={1} className={"d-flex justify-content-end"}>
                  <Field
                    name="nfcHyperlink"
                    component={SwitchInputField}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    onColor="#2ECC71"
                    offColor="#E74C3C"
                    height={20}
                    width={40}
                    handleDiameter={18}
                  />
                </Col>
              </Row>
              <Row style={{ borderBottom: "1px solid lightgray" }}>
                <Col xs={11}>
                  <p className="pt-3">Inbox</p>
                </Col>
                <Col xs={1} className={"d-flex justify-content-end"}>
                  <Field
                    name="webInboxEnabled"
                    component={SwitchInputField}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    onColor="#2ECC71"
                    offColor="#E74C3C"
                    height={20}
                    width={40}
                    handleDiameter={18}
                  />
                </Col>
              </Row>
              <Row style={{ borderBottom: "1px solid lightgray" }}>
                <Col xs={11}>
                  <p className="pt-3">Landing Page</p>
                </Col>
                <Col xs={1} className={"d-flex justify-content-end"}>
                  <Field
                    name="landingPage"
                    component={SwitchInputField}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    onColor="#2ECC71"
                    offColor="#E74C3C"
                    height={20}
                    width={40}
                    handleDiameter={18}
                  />
                </Col>
              </Row>
              <Row style={{ borderBottom: "1px solid lightgray" }}>
                <Col xs={11}>
                  <p className="pt-3">Location Services</p>
                </Col>
                <Col xs={1} className={"d-flex justify-content-end"}>
                  <Field
                    name="locationServices"
                    component={SwitchInputField}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    onColor="#2ECC71"
                    offColor="#E74C3C"
                    height={20}
                    width={40}
                    handleDiameter={18}
                  />
                </Col>
              </Row>
              <Row style={{ borderBottom: "1px solid lightgray" }}>
                <Col xs={11}>
                  <p className="pt-3">News Feed</p>
                </Col>
                <Col xs={1} className={"d-flex justify-content-end"}>
                  <Field
                    name="newsFeed"
                    component={SwitchInputField}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    onColor="#2ECC71"
                    offColor="#E74C3C"
                    height={20}
                    width={40}
                    handleDiameter={18}
                  />
                </Col>
              </Row>
              <Row style={{ borderBottom: "1px solid lightgray" }}>
                <Col xs={11}>
                  <p className="pt-3">Products & Subscriptions</p>
                </Col>
                <Col xs={1} className={"d-flex justify-content-end"}>
                  <Field
                    name="productsAndSubscriptions"
                    component={SwitchInputField}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    onColor="#2ECC71"
                    offColor="#E74C3C"
                    height={20}
                    width={40}
                    handleDiameter={18}
                  />
                </Col>
              </Row>
              <Row style={{ borderBottom: "1px solid lightgray" }}>
                <Col xs={11}>
                  <p className="pt-3">QR/Text Code</p>
                </Col>
                <Col xs={1} className={"d-flex justify-content-end"}>
                  <Field
                    name="qrCode"
                    component={SwitchInputField}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    onColor="#2ECC71"
                    offColor="#E74C3C"
                    height={20}
                    width={40}
                    handleDiameter={18}
                  />
                </Col>
              </Row>
              <Row style={{ borderBottom: "1px solid lightgray" }}>
                <Col xs={11}>
                  <p className="pt-3">Search Field</p>
                </Col>
                <Col xs={1} className={"d-flex justify-content-end"}>
                  <Field
                    name="searchField"
                    component={SwitchInputField}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    onColor="#2ECC71"
                    offColor="#E74C3C"
                    height={20}
                    width={40}
                    handleDiameter={18}
                  />
                </Col>
              </Row>
              <Row style={{ borderBottom: "1px solid lightgray" }}>
                <Col xs={11}>
                  <p className="pt-3">
                    Send survey/form_builder filled out email to sender
                  </p>
                </Col>
                <Col xs={1} className={"d-flex justify-content-end"}>
                  <Field
                    name="sendFeatureFilledOutEmail"
                    component={SwitchInputField}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    onColor="#2ECC71"
                    offColor="#E74C3C"
                    height={20}
                    width={40}
                    handleDiameter={18}
                  />
                </Col>
              </Row>
              <Row style={{ borderBottom: "1px solid lightgray" }}>
                <Col xs={11}>
                  <p className="pt-3">Show pending users in DP</p>
                </Col>
                <Col xs={1} className={"d-flex justify-content-end"}>
                  <Field
                    name="pendingUsersDP"
                    component={SwitchInputField}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    onColor="#2ECC71"
                    offColor="#E74C3C"
                    height={20}
                    width={40}
                    handleDiameter={18}
                  />
                </Col>
              </Row>
              <Row style={{ borderBottom: "1px solid lightgray" }}>
                <Col xs={11}>
                  <p className="pt-3">Skip Landing Screen if Logged In</p>
                </Col>
                <Col xs={1} className={"d-flex justify-content-end"}>
                  <Field
                    name="skipLandingScreen"
                    component={SwitchInputField}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    onColor="#2ECC71"
                    offColor="#E74C3C"
                    height={20}
                    width={40}
                    handleDiameter={18}
                  />
                </Col>
              </Row>
              <Row style={{ borderBottom: "1px solid lightgray" }}>
                <Col xs={11}>
                  <p className="pt-3">Social Profile</p>
                </Col>
                <Col xs={1} className={"d-flex justify-content-end"}>
                  <Field
                    name="socialProfile"
                    component={SwitchInputField}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    onColor="#2ECC71"
                    offColor="#E74C3C"
                    height={20}
                    width={40}
                    handleDiameter={18}
                  />
                </Col>
              </Row>
              <Row style={{ borderBottom: "1px solid lightgray" }}>
                <Col xs={11}>
                  <p className="pt-3">Visitor Status (un-logged in users)</p>
                </Col>
                <Col xs={1} className={"d-flex justify-content-end"}>
                  <Field
                    name="visitorStatus"
                    component={SwitchInputField}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    onColor="#2ECC71"
                    offColor="#E74C3C"
                    height={20}
                    width={40}
                    handleDiameter={18}
                    onChange={(event, newValue) => {
                      if (!newValue) {
                        change("settings_setup.disableLogIns", false)
                      }
                    }}
                  />
                </Col>
              </Row>
              <Row
                className="ms-5"
                style={{ borderBottom: "1px solid lightgray" }}
              >
                <Col xs={11}>
                  <p className="pt-3">
                    Disable Log Ins (Visitors must be enabled)
                  </p>
                </Col>
                <Col xs={1} className={"d-flex justify-content-end"}>
                  <Field
                    name="disableLogIns"
                    component={SwitchInputField}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    onColor="#2ECC71"
                    offColor="#E74C3C"
                    height={20}
                    width={40}
                    handleDiameter={18}
                    disabled={!visitorStatus}
                  />
                </Col>
              </Row>
              <Row className="my-3 justify-content-center">
                <Col xl={1}>
                  <SaveButton
                    type="button"
                    content="Save"
                    onClick={saveHandler}
                    fullWidth={true}
                  />
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  )
}

const selector = formValueSelector(FORM_NAMES.VENDOR_FEATURES)

const mapStateToProps = state => {
  // Extract the existing vendorConfig
  const vendorConfig = state.clients.vendorConfig
  return {
    vendorConfig: vendorConfig, // Map the updated config to props
    visitorStatus: selector(state, "settings_setup.visitorStatus"),
    formSyncErrors: getFormSyncErrors(FORM_NAMES.VENDOR_FEATURES)(state),
    settingsFormValues: selector(state, "settings_setup"),
  }
}

const mapDispatchToProps = dispatch => ({
  change: (field, value) => {
    dispatch(change(FORM_NAMES.VENDOR_FEATURES, `${field}`, value))
  },
  updateClientSettings: values => dispatch(updateClientSettings(values)),
})

export default connect(mapStateToProps, mapDispatchToProps)(SettingsTab)
